// 获取活动列表
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST';

// 获取首页活动列表
export const GET_ACTIVITY_HOME_LIST = 'GET_ACTIVITY_HOME_LIST';

// 获取活动详情
export const GET_ACTIVITY_DETAIL = 'GET_ACTIVITY_DETAIL';

// 参与活动
export const PLAY_ACTIVITY = 'PLAY_ACTIVITY';

// 销毁当前活动数据
export const DISTROY_ACTIVITY_DETAIL = 'DISTROY_ACTIVITY_DETAIL'; 